import React, { Fragment, useState, useEffect } from "react";
import SelectReact from 'react-select'

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Select(props) {
  const { form, field } = props;
  useEffect(() => {
    if (field.value != undefined && props.options) {
      setSelected(
        props.options &&
          props.options.filter((item) => item.value == field.value)[0]
      );
    }
  }, [props.options]);

  const [selected, setSelected] = useState([]);
  const onChangeHandler = (item) => {
    if(!item)
    {
      form.setFieldValue(field.name, null);
    setSelected(null);
    if (props.alsoOnchange) {
      props.alsoOnchange(null);
    }
    return;
    }
    form.setFieldValue(field.name, item.value);
    setSelected(item);
    if (props.alsoOnchange) {
      props.alsoOnchange(item.value);
    }
  };

  
  return (
    <div
      className="text-sx col-span-2"
      style={{ zIndex: 99, position: "relative" }}
    >
       <label
        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
        htmlFor={field.name}
      >
        {props.label}
      </label>
     <SelectReact   placeholder="انتخاب..."  value = {
            props.options.filter(option => 
               option === selected)
         }  onChange = {onChangeHandler} options={props.options}
         
         menuPortalTarget={document.body} 
         //clearValue={onClearHandler}
         styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} isClearable={true}/>
      <span className="text-xs text-red-400">{form.errors[field.name]}</span>
    </div>
  );
}
